import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import DipartimentiTable from './DipartimentiTable'
import DipartimentiReportList from './DipartimentiReportList'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import DipartimentoForm from './DipartimentoForm'
import RubricaOggettiOrfani from './RubricaOggettiOrfani'
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import RubricaElencoDipartimenti from "../../pdf/RubricaElencoDipartimenti";

class DipartimentiList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: 'nome',
                direction: 'A',
                data: [{field: 'd.nome', direction: 'A'}]},
            filterInfo: {},
            _loading: false,
            error: null,
            showItem: null,
            listViewType: 'l',
            statoDipartimento: 'S',
            dipartimentoInEdit: undefined,
            dipartimentoSaved: undefined,
        };
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeFilterDipartimento = this.onChangeFilterDipartimento.bind(this)
        this.onChangeFilterOrganizzazione = this.onChangeFilterOrganizzazione.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.onNewClick = this.onNewClick.bind(this)
        this.onEditClick = this.onEditClick.bind(this)
        this.loadData = this.loadData.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
        this.renderList = this.renderList.bind(this)
        this.onDipartimentoStateChange = this.onDipartimentoStateChange.bind(this)
        this.onChangeMostraOrfani = this.onChangeMostraOrfani.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.dipartimento !== undefined && this.state.filterInfo.dipartimento !== ''){
            msg += 'Nome dipartimento contenente: ' + this.state.filterInfo.dipartimento;
        }
        if (this.state.filterInfo.organizzazione !== undefined && this.state.filterInfo.organizzazione !== ''){
            msg += 'Nome organizzazione contenente: ' + this.state.filterInfo.organizzazione;
        }
        return  msg.trim();
    }
    componentWillMount() {
    }

    componentWillUnmount() {
        if (this.storeInstance) this.storeInstance.save('DipartimentiList', this.state);
    }

    cfgLoaded(cfg, error){
        if (cfg !== undefined){
            this.setState({cfg});
        }
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('DipartimentiList', this , () => {

                if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
                {
                    if (this.props.location.state.from.pathname.includes("dipartimenti/edit"))
                    {
                        let dipartimento = this.props.location.state.item.dipartimento;
                        let items = this.state.items.map((cit) => {
                            if (cit.idDipartimento === dipartimento.idDipartimento)
                            {
                                return dipartimento;
                            }
                            return cit;
                        });
                        this.setState({items: items, showItem: dipartimento});
                    }
                    else if (this.props.location.state.from.pathname.includes("dipartimenti/new"))
                    {
                        let dipartimento = this.props.location.state.item.dipartimento;
                        let items = [dipartimento];
                        this.setState({items: items.concat(this.state.items), showItem: dipartimento});
                    }
                }
                else {
                    this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
                }
            }) === null){
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangePage(newpage) {

        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo)
    }

    onChangeFilter(data){
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, data)
    }

    onChangeFilterDipartimento(data){
        let fi = this.state.filterInfo;
        fi.dipartimento = data ? data.keyword : undefined;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi)
    }
    onChangeFilterOrganizzazione(data){
        let fi = this.state.filterInfo;
        fi.organizzazione = data ? data.keyword : undefined;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi)
    }

    onChangeMostraOrfani(mostraOrfani){
        let fi = this.state.filterInfo;
        fi.mostraOrfani = mostraOrfani;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi);
    }

    pdfExport(tipo){
        this.loadCompleteData(tipo, this.state.orderInfo, this.state.filterInfo);
    }

    loadCompleteData(tipo, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadDipartimentiList(
            this.rowperpage,
            -1,
            orderInfo.data,
            filterInfo, true
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        _loading: false,
                        error: null,
                    }, ()=>{
                        let ce = new RubricaElencoDipartimenti();
                        ce.setTitle("Report Dipartimenti");
                        ce.setFileName("report-dipartimenti.pdf");
                        ce.setFilterDescription(this.getFilterDescription());
                        ce.createPdf(data.items);
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadDipartimentiList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo, true
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null,
                        showItem: null,
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onNewClick(){
        this.setState({statoDipartimento:'N'})
    }

    onEditClick(dipartimento){
        this.setState({statoDipartimento:'E', dipartimentoInEdit: dipartimento})
    }

    onDipartimentoStateChange(statoDipartimento, dipartimento, forceUpdate = false){
        let prevState = this.state.statoDipartimento;
        this.setState({
            statoDipartimento: statoDipartimento,
            dipartimentoSaved: dipartimento,
        });
        if (dipartimento !== undefined){
            if (prevState !== 'S' || forceUpdate){
                if (prevState === 'E') {
                    // Vengo da un edit
                    let items = this.state.items.map((cit) => {
                        if (cit.idDipartimento === dipartimento.idDipartimento)
                        {
                            return dipartimento;
                        }
                        return cit;
                    });
                    this.setState({items: items});
                }
                else {
                    // Vengo da un'aggiunta.
                    let items = [dipartimento];
                    this.setState({items: items.concat(this.state.items)});
                }
            }
        }
    }

    onDeleteClick(ev, dipartimento){
        this.setState({_loading: true});
        client.deleteDipartimento(dipartimento).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }

    cambiaTipoLista(tipo) {
        this.setState({listViewType: tipo}, () => {
            if (tipo === 'r'){
                //Ricarico senza paginazione
                this.loadData(-1, this.state.orderInfo, this.state.filterInfo);
            } else if (this.state.page === -1){
                // Vengo dalla visualzizzazione report, reimposto la pagina a 1
                this.loadData(1, this.state.orderInfo, this.state.filterInfo);
            }
        });
    }

    renderDipartimento() {
        return (
            <DipartimentoForm
                idDipartimento={this.state.statoDipartimento === 'N' ? undefined : this.state.dipartimentoInEdit.idDipartimento}
                onSaved={(dipartimento) => (this.onDipartimentoStateChange('S', dipartimento))}
                onCancel={(dipartimento) => (this.onDipartimentoStateChange('S', dipartimento))}
            />
        )
    }

    renderList() {
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                    <div className="ui huge loader"></div>
                </div>
            );
        }
        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui two column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Dipartimenti soddisfano i filtri specificati
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                            {/*<ListTypeButton*/}
                                {/*listType={this.state.listViewType}*/}
                                {/*onButtonClick={(t) => {this.cambiaTipoLista(t)}}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">
                <div className="ui three column stackable grid">
                    <div className="six wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.dipartimento}
                            placeholder="Nome del dipartimento..."
                            onChangeFilter={this.onChangeFilterDipartimento} />
                    </div>
                    <div className="six wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.organizzazione}
                            placeholder="Nome dell'organizzazione..."
                            onChangeFilter={this.onChangeFilterOrganizzazione} />
                    </div>
                    <div className="four wide column">
                        <RubricaOggettiOrfani
                            label="Mostra Dipartimenti senza Soggetti"
                            mostraOrfani={this.state.filterInfo.mostraOrfani}
                            onChange={this.onChangeMostraOrfani}
                        />
                    </div>
                </div>
            </div>

            {
                this.state.listViewType === 'l' ? (

                    <DipartimentiTable
                        items={this.state.items}
                        senderList={this.state.senderList}
                        count={this.state.total}
                        page={this.state.page}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onDeleteItem={this.onDeleteClick}
                        onNuovoItem={this.onNewClick}
                        onModificaItem={this.onEditClick}
                        filterDescription={this.getFilterDescription()}
                        onExportPdf={this.pdfExport}
                        readOnly={client.getCurrentUser().isrolerubricaw==false}
                    />)

                    :

                    <DipartimentiReportList
                        items={this.state.items}
                        filterDescription={this.getFilterDescription()}/>

            }
            {loader}
        </div>)
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={() => {this.setState({error:null})}} />)
        }

        if (this.state.statoDipartimento !== 'S'){
            return (
                <div>
                    {this.renderDipartimento()}
                </div>
            )
        }

        return this.renderList()
    }
}

DipartimentiList.contextTypes = {
    router: PropTypes.object
}

export default DipartimentiList;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/DipartimentiList.js
 **/